import { combineReducers } from 'redux';

import { IProjectFilter, IProjectList } from '../../../models';
import { generateAsyncReducer } from '../../../utils';
import { IProjectsState, ISingleProject } from '../models';
import { EProjectsActions } from './enums';

export const ProjectsReducers = combineReducers<IProjectsState>({
    project: generateAsyncReducer<ISingleProject>(EProjectsActions.GET_PROJECT),
    projects: generateAsyncReducer<IProjectList>(EProjectsActions.GET_PROJECTS),
    filter: generateAsyncReducer<IProjectFilter[]>(EProjectsActions.GET_FILTERS),
});
